import { useState } from "react";
import Popup from "../other/Popup";
import { can } from "../../utils/permissions";
import { parseNullableInteger, sanitizeUserIdentityFields } from "./userFieldUtils";

function CreateUser(props) {
    const { closed, setClosed, socket, userInfo, userId } = props;

    const [nom, setNom] = useState('');
    const [cognom, setCognom] = useState('');
    const [segonCognom, setSegonCognom] = useState('');
    const [mote, setMote] = useState('');
    const [altura, setAltura] = useState('');
    const [altura_mans, setAlturaMans] = useState('');
    const [tecnica, setTecnica] = useState(0);
    const [junta, setJunta] = useState(0);
    const [canalla, setCanalla] = useState(false);
    const [music, setMusic] = useState(false);
    const [lesionat, setLesionat] = useState(false);
    const [casteller, setCasteller] = useState(true);
    const [novell, setNovell] = useState(false);
    const [passwordOption, setPasswordOption] = useState('default');
    const [mail, setMail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const createUser = () => {
        const identityFields = sanitizeUserIdentityFields({
            'nom': nom,
            'primer-cognom': cognom,
            'segon-cognom': segonCognom,
            'mote': mote,
            'mail': mail,
        });

        if (identityFields.nom === '' || identityFields['primer-cognom'] === '') {
            alert('El nom i el cognom són camps obligatoris.');
            return;
        }

        if (isSubmitting) return;

        const responses = {
            ...identityFields,
            'altura': parseNullableInteger(altura),
            'altura_mans': parseNullableInteger(altura_mans),
            'tecnica': parseInt(tecnica),
            'junta': parseInt(junta),
            'canalla': canalla ? 1 : 0,
            'music': music ? 1 : 0,
            'lesionat': lesionat ? 1 : 0,
            'casteller': casteller ? 1 : 0,
            'novell': novell ? 1 : 0,
            'password_option': passwordOption,
            '_actorId': userId || userInfo?.id, // Fallback for socket.userId
            // soci is automatically managed based on quote payments
        };

        setIsSubmitting(true);

        socket.emit('.create_user', responses, (response) => {
            setIsSubmitting(false);

            if (!response || response.success !== true) {
                if (response?.reason === 'duplicate') {
                    const segon = response['segon-cognom'] ? ` ${response['segon-cognom']}` : '';
                    alert(`Ja existeix un casteller anomenat ${response.nom} ${response['primer-cognom']}${segon}.`);
                } else if (response?.reason === 'duplicate_deleted') {
                    const segon = response['segon-cognom'] ? ` ${response['segon-cognom']}` : '';
                    const shouldRestore = window.confirm(`Ja existeix un casteller eliminat anomenat ${response.nom} ${response['primer-cognom']}${segon}.\n\nVols restaurar aquest casteller?`);

                    if (!shouldRestore) {
                        return;
                    }

                    if (!response.duplicateUserId) {
                        alert('No s\'ha pogut identificar el casteller eliminat per restaurar.');
                        return;
                    }

                    setIsSubmitting(true);
                    socket.emit('.restore_user', {
                        id: response.duplicateUserId,
                        _actorId: userId || userInfo?.id,
                    }, (restoreResponse) => {
                        setIsSubmitting(false);

                        if (!restoreResponse?.success) {
                            alert(restoreResponse?.error || 'No s\'ha pogut restaurar el casteller.');
                            return;
                        }

                        socket.emit('.request_users');
                        setClosed(true);
                    });
                } else if (response?.reason === 'validation' || response?.reason === 'permission') {
                    alert(response?.error || 'No s\'ha pogut crear el casteller.');
                } else {
                    alert('No s\'ha pogut crear el casteller. Torna-ho a provar.');
                }
                return;
            }

            socket.emit('.request_users');
            setClosed(true);
        });
    };

    if (!closed) {
        const inputStyle = {
            padding: '8px 12px',
            fontSize: '14px',
            border: '1px solid #d0d0d0',
            borderRadius: '4px',
            width: '100%',
            boxSizing: 'border-box',
            backgroundColor: '#fafafa',
        };

        const radioGroupStyle = {
            display: 'flex',
            gap: '16px',
            alignItems: 'center',
            padding: '8px 0',
        };

        const labelStyle = {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            cursor: 'pointer',
        };

        const checkboxLabelStyle = {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            cursor: 'pointer',
            padding: '4px 0',
        };

        const fieldGroupStyle = {
            marginBottom: '16px',
        };

        const fieldLabelStyle = {
            fontSize: '13px',
            fontWeight: '600',
            color: '#333',
            marginBottom: '6px',
            display: 'block',
        };

        const sectionStyle = {
            padding: '16px 0',
            borderBottom: '1px solid #e8e8e8',
        };

        const buttonStyle = {
            padding: '10px 24px',
            fontSize: '15px',
            fontWeight: '500',
            border: '1px solid #2563eb',
            borderRadius: '4px',
            backgroundColor: '#2563eb',
            color: 'white',
            cursor: isSubmitting ? 'not-allowed' : 'pointer',
            opacity: isSubmitting ? 0.7 : 1,
        };

        const cancelButtonStyle = {
            padding: '10px 24px',
            fontSize: '15px',
            fontWeight: '500',
            border: '1px solid #d0d0d0',
            borderRadius: '4px',
            backgroundColor: 'white',
            color: '#333',
            cursor: 'pointer',
            textDecoration: 'none',
        };

        return (
            <Popup closed={closed} setClosed={setClosed}>
                <div style={{ padding: '8px 16px' }}>
                    <h2 style={{ margin: '0 0 20px 0', fontSize: '22px', fontWeight: '600', color: '#1a1a1a' }}>Crear casteller</h2>
                    
                    {/* Informació personal */}
                    <div style={sectionStyle}>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>Nom *</label>
                            <input type="text" style={inputStyle} defaultValue={nom} onChange={e => setNom(e.target.value)} placeholder="Introdueix el nom" />
                        </div>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>1r cognom *</label>
                            <input type="text" style={inputStyle} defaultValue={cognom} onChange={e => setCognom(e.target.value)} placeholder="Introdueix el primer cognom" />
                        </div>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>2n cognom</label>
                            <input type="text" style={inputStyle} defaultValue={segonCognom} onChange={e => setSegonCognom(e.target.value)} placeholder="Introdueix el segon cognom (opcional)" />
                        </div>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>Sobrenom</label>
                            <input type="text" style={inputStyle} defaultValue={mote} onChange={e => setMote(e.target.value)} placeholder="Introdueix el sobrenom" />
                        </div>
                    </div>

                    {/* Característiques físiques */}
                    <div style={sectionStyle}>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>Altura (cm)</label>
                            <input type="number" style={inputStyle} defaultValue={altura} onChange={e => setAltura(e.target.value)} onWheel={(e) => e.target.blur()} placeholder="Introdueix l'altura en cm" />
                        </div>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>Altura mans (cm)</label>
                            <input type="number" style={inputStyle} defaultValue={altura_mans} onChange={e => setAlturaMans(e.target.value)} onWheel={(e) => e.target.blur()} placeholder="Introdueix l'altura de mans en cm" />
                        </div>
                    </div>

                    {/* Rols */}
                    <div style={sectionStyle}>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>És tècnica:</label>
                            <div style={radioGroupStyle}>
                                { can(props.userInfo, 'ASSIGN_HEAD_TECNICA') ? 
                                    <label style={labelStyle}>
                                        <input onChange={() => setTecnica(2)} name="tecnica" type="radio" defaultChecked={parseInt(tecnica) === 2} />
                                        <span>Cap de tècnica</span>
                                    </label> : null 
                                }
                                { can(props.userInfo, 'ASSIGN_TECNICA') ?
                                    <label style={labelStyle}>
                                        <input onChange={() => setTecnica(1)} name="tecnica" type="radio" defaultChecked={parseInt(tecnica) === 1} />
                                        <span>Tècnica</span>
                                    </label> : null
                                }
                                <label style={labelStyle}>
                                    <input onChange={() => setTecnica(0)} name="tecnica" type="radio" defaultChecked={parseInt(tecnica) === 0} />
                                    <span>No tècnica</span>
                                </label>
                            </div>
                        </div>
                        
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>És junta:</label>
                            <div style={radioGroupStyle}>
                                { can(props.userInfo, 'ASSIGN_HEAD_JUNTA') ? 
                                    <label style={labelStyle}>
                                        <input onChange={() => setJunta(2)} name="junta" type="radio" defaultChecked={parseInt(junta) === 2} />
                                        <span>Cap de junta</span>
                                    </label> : null 
                                }
                                { can(props.userInfo, 'ASSIGN_JUNTA') ?
                                    <label style={labelStyle}>
                                        <input onChange={() => setJunta(1)} name="junta" type="radio" defaultChecked={parseInt(junta) === 1} />
                                        <span>Junta</span>
                                    </label> : null
                                }
                                <label style={labelStyle}>
                                    <input onChange={() => setJunta(0)} name="junta" type="radio" defaultChecked={parseInt(junta) === 0} />
                                    <span>No junta</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* Estats */}
                    <div style={sectionStyle}>
                        <label style={{ ...fieldLabelStyle, marginBottom: '12px' }}>Estat:</label>
                        <div>
                            <label style={checkboxLabelStyle}>
                                <input type="checkbox" checked={casteller} onChange={e => setCasteller(e.target.checked)} />
                                <span>És casteller</span>
                            </label>
                            <label style={checkboxLabelStyle}>
                                <input type="checkbox" checked={novell} onChange={e => setNovell(e.target.checked)} />
                                <span>És novell</span>
                            </label>
                            <label style={checkboxLabelStyle}>
                                <input type="checkbox" checked={canalla} onChange={e => setCanalla(e.target.checked)} />
                                <span>És canalla</span>
                            </label>
                            <label style={checkboxLabelStyle}>
                                <input type="checkbox" checked={music} onChange={e => setMusic(e.target.checked)} />
                                <span>És músic</span>
                            </label>
                            <label style={checkboxLabelStyle}>
                                <input type="checkbox" checked={lesionat} onChange={e => setLesionat(e.target.checked)} />
                                <span>Està lesionat</span>
                            </label>
                        </div>
                    </div>

                    {/* Contrasenya */}
                    <div style={{ ...sectionStyle, borderBottom: 'none' }}>
                        <div style={fieldGroupStyle}>
                            <label style={fieldLabelStyle}>Contrasenya:</label>
                            <div style={radioGroupStyle}>
                                <label style={labelStyle}>
                                    <input onChange={() => setPasswordOption('default')} name="password" type="radio" checked={passwordOption === 'default'} />
                                    <span>Contrasenya aleatòria</span>
                                </label>
                                <label style={labelStyle}>
                                    <input onChange={() => setPasswordOption('empty')} name="password" type="radio" checked={passwordOption === 'empty'} />
                                    <span>Sense contrasenya</span>
                                </label>
                            </div>
                        </div>
                        
                        {passwordOption === 'default' && (
                            <div style={{ ...fieldGroupStyle, marginTop: '12px' }}>
                                <label style={fieldLabelStyle}>Enviar contrasenya per mail (opcional):</label>
                                <input 
                                    type="email" 
                                    style={inputStyle} 
                                    defaultValue={mail} 
                                    onChange={e => setMail(e.target.value)} 
                                    placeholder="mail-per@enviar-la-contrasenya.com" 
                                />
                            </div>
                        )}
                    </div>

                    {/* Botons */}
                    <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e8e8e8' }}>
                        <button style={cancelButtonStyle} onClick={() => setClosed(true)}>Cancel·lar</button>
                        <button style={buttonStyle} onClick={() => createUser()} disabled={isSubmitting}>
                            {isSubmitting ? 'Creant…' : 'Crear'}
                        </button>
                    </div>
                </div>
            </Popup>
        );
    }
}

export default CreateUser;
